const doc = [({"no":({"js":({"routes":({"user":({"school_class_courses":({"show":({"go_to_the_space_of_the_class":"Gå til klasserommet"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;